import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { AdminAnalytics } from "@/pages/admin/AdminAnalytics";
import { AdminSettings } from "@/pages/admin/AdminSettings";
import { AdminUsers } from "@/pages/admin/AdminUsers";
import { AdminLayers } from "@/pages/admin/AdminLayers";
import { AdminNotes } from "@/pages/admin/AdminNotes";
import { AdminLocations } from "@/pages/admin/AdminLocations";
import { AdminLibrary } from "@/pages/admin/AdminLibrary";
import { AdminHomepage } from "@/pages/admin/AdminHomepage";
import { AdminFileMapping } from "@/pages/admin/AdminFileMapping";
import { AdminEmails } from "@/pages/admin/AdminEmails";

export default function Admin() {
  return (
    <div data-testid="admin-page" className="max-w-7xl mx-auto px-6 py-12">
      <p className="data-label mb-3">Superadmin</p>
      <h1 className="text-3xl sm:text-4xl font-extrabold tracking-tight">Control room</h1>
      <p className="text-muted-foreground mt-2">Pricing, site mode, map provider, users and live analytics.</p>
      <Tabs defaultValue="analytics" className="mt-10">
        <TabsList className="rounded-full h-11 p-1 flex-wrap">
          <TabsTrigger data-testid="admin-tab-analytics" value="analytics" className="rounded-full px-5">Analytics</TabsTrigger>
          <TabsTrigger data-testid="admin-tab-settings" value="settings" className="rounded-full px-5">Settings</TabsTrigger>
          <TabsTrigger data-testid="admin-tab-users" value="users" className="rounded-full px-5">Users</TabsTrigger>
          <TabsTrigger data-testid="admin-tab-layers" value="layers" className="rounded-full px-5">Map layers</TabsTrigger>
          <TabsTrigger data-testid="admin-tab-notes" value="notes" className="rounded-full px-5">Field notes</TabsTrigger>
          <TabsTrigger data-testid="admin-tab-locations" value="locations" className="rounded-full px-5">Locations</TabsTrigger>
          <TabsTrigger data-testid="admin-tab-file-mapping" value="file-mapping" className="rounded-full px-5">File mapping</TabsTrigger>
          <TabsTrigger data-testid="admin-tab-library" value="library" className="rounded-full px-5">Library</TabsTrigger>
          <TabsTrigger data-testid="admin-tab-homepage" value="homepage" className="rounded-full px-5">Homepage & Pricing</TabsTrigger>
          <TabsTrigger data-testid="admin-tab-emails" value="emails" className="rounded-full px-5">Emails</TabsTrigger>
        </TabsList>
        <TabsContent value="emails" className="mt-6"><AdminEmails /></TabsContent>
        <TabsContent value="file-mapping" className="mt-6"><AdminFileMapping /></TabsContent>
        <TabsContent value="homepage" className="mt-6"><AdminHomepage /></TabsContent>
        <TabsContent value="library" className="mt-6"><AdminLibrary /></TabsContent>
        <TabsContent value="locations" className="mt-6"><AdminLocations /></TabsContent>
        <TabsContent value="notes" className="mt-6"><AdminNotes /></TabsContent>
        <TabsContent value="analytics" className="mt-6"><AdminAnalytics /></TabsContent>
        <TabsContent value="settings" className="mt-6"><AdminSettings /></TabsContent>
        <TabsContent value="users" className="mt-6"><AdminUsers /></TabsContent>
        <TabsContent value="layers" className="mt-6"><AdminLayers /></TabsContent>
      </Tabs>
    </div>
  );
}
